"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _queryString = _interopRequireDefault(require("query-string"));

var _utils = require("@alycecom/utils");

var _useAuthService2 = require("../hooks/useAuthService");

var _store = require("../store");

var _AuthLoading = _interopRequireDefault(require("./AuthLoading"));

var FullLogoImage = function FullLogoImage(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#6FD78A",
    d: "M16.61 27.262c-.008-.002-6.06-1.655-10.122-4.685 0 0-.794-.603-.997-.806L0 24.007c2.173 5.398 7.631 8.527 13.144 8.014a12.68 12.68 0 0 0 1.514-.147l1.952-4.612z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#0CBEB8",
    d: "M12.798 18.816l-.528-.641a12.899 12.899 0 0 1-2.93-8.04L2.225 7.119c-2.2 5.195-.71 11.072 3.263 14.66l7.31-2.962z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#1AA799",
    d: "M16.46 23.266l-3.658-4.446-.004-.004-7.31 2.961.013.011.036.034c.292.256.6.503.922.742 4.061 3.031 10.144 4.696 10.15 4.698l.001-.001c.725-1.455.968-2.593-.15-3.995"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F4D138",
    d: "M48.149 7.577H34.28c-4.46 0-8.165 1.816-10.53 4.27 0 0 2.915 3.539 2.984 3.618 1.212 1.4 1.99 1.615 4.051 1.305l4.345-.681c2.101-4.605 5.535-6.765 11.293-6.765h1.81c1.252 0 1.325-1.747-.085-1.747"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#029CEF",
    d: "M21.475 15.305h.001l.094-.224c.48-1.131 1.22-2.234 2.181-3.233L13.998 0C10.883 2.581 9.293 6.354 9.34 10.136l12.135 5.169z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#1E778B",
    d: "M9.34 10.136v.013c.04 2.838 1 5.68 2.93 8.026l.528.64 8.677-3.51-12.135-5.17z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#5A76B1",
    d: "M14.659 31.873l-2.572 6.083c5.065 2.158 13.676.279 15.878-4.942l.326-.78-3.039-2.319c-1.455-1.094-2.226-1.314-4.362-.45l-.03.013c-.397.174-5.195 2.27-6.204 2.401l.003-.006z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#33457C",
    d: "M30.82 16.765c-2.087.318-2.867.11-4.088-1.296l-2.981-3.621c-.962.998-1.702 2.103-2.181 3.234l-.094.223-8.678 3.51 3.663 4.451c1.117 1.402.874 2.54.15 3.995l-1.953 4.613c1.01-.132 5.805-2.221 6.203-2.395l.03-.013c2.156-.874 2.921-.64 4.405.482l2.995 2.286 6.84-16.144-4.312.675zm82.496 6.881h-8.936c.289-2.896 2.43-4.195 4.452-4.195 2.027 0 4.18 1.298 4.484 4.195m3.443 1.199c0-4.048-2.48-8.405-7.927-8.405-2.55 0-4.644.949-6.058 2.744-1.225 1.557-1.9 3.716-1.9 6.08 0 3.035.877 5.34 2.607 6.853 1.774 1.552 4 1.878 5.554 1.878 3.492 0 6.793-1.595 6.793-3.281 0-.847-.647-1.51-1.474-1.51a1.85 1.85 0 0 0-.926.264c-1.327.897-2.57 1.352-3.694 1.352-3.033 0-4.923-1.51-5.339-4.26h10.621c1.01 0 1.743-.721 1.743-1.715m-22.985-5.231c1.637 0 2.496.444 3.58 1.003.341.19.548.225.832.225.836 0 1.484-.836 1.484-1.554 0-.542-.27-1.021-.76-1.35-1.144-.741-2.79-1.593-5.394-1.593-2.377 0-4.577.826-6.192 2.327-1.746 1.622-2.67 3.87-2.67 6.498s.924 4.875 2.67 6.497c1.616 1.501 3.815 2.328 6.192 2.328 2.602 0 4.248-.852 5.393-1.595.49-.327.761-.807.761-1.349 0-.718-.648-1.554-1.484-1.554-.284 0-.492.035-.832.226-1.042.538-1.943 1.002-3.58 1.002-3.495 0-5.666-2.128-5.666-5.555 0-3.427 2.171-5.556 5.666-5.556m-38.543 6.66v2.362c-.99 1.104-2.737 2.27-4.715 2.27-2.1 0-3.164-.786-3.164-2.333 0-1.547 1.51-2.3 4.618-2.3h3.261zm3.462 2.982c-.087-2.214-.01-5.865 0-6.288 0-1.763-.596-3.383-1.677-4.564-1.25-1.365-3.095-2.086-5.337-2.086-1.984 0-3.793.377-5.69 1.187-.636.263-1 .8-1 1.473 0 .837.64 1.493 1.456 1.493.13 0 .292-.024.492-.075 1.244-.404 2.503-.767 4.225-.767 2.89 0 4.068 1.088 4.07 3.755h-3.65c-4.816 0-7.692 2.061-7.692 5.513 0 3.364 2.78 5.124 5.527 5.124 2.354 0 4.35-.748 5.936-2.224.24.752.875 2.062 2.374 2.062.118 0 .235-.011.349-.034.456-.093.836-.39 1.045-.818a1.684 1.684 0 0 0-.008-1.477c-.193-.39-.423-1.1-.42-2.274zm10.489 7.327zm.012.129zm13.028-20.233c-.705 0-1.271.4-1.597 1.13l-4.829 11.729-4.74-11.792a1.756 1.756 0 0 0-1.598-1.067c-.945 0-1.714.786-1.714 1.752 0 .299.093.576.15.716L73.992 33.8c-.074.555-.752 1.666-.777 1.707a2.453 2.453 0 0 1-.252.297l-.077.08a2.953 2.953 0 0 1-1.1.71l-.03.01a2.847 2.847 0 0 1-1.335.145l-.017-.008-.03.005a1.29 1.29 0 0 1-.182-.033 2.499 2.499 0 0 1-.427-.15 1.476 1.476 0 0 0-1.64.349 1.35 1.35 0 0 0-.367 1.014 1.627 1.627 0 0 0 .033.24c.064.32.149.54.275.715.129.177.312.34.5.446.465.26.975.446 1.514.55.13.028.257.05.38.065l.03.004.005-.13h.01l.19.02-.012.13a5.442 5.442 0 0 0 1.288-.042 6.307 6.307 0 0 0 1.138-.307 5.739 5.739 0 0 0 2.586-1.87l.022-.027a7.736 7.736 0 0 0 .274-.372 3.868 3.868 0 0 0 .267-.468l.012-.027c.01-.022.02-.046.033-.07.04-.076.077-.16.108-.246 1.404-3.13 7.348-17.511 7.408-17.657.076-.188.116-.413.116-.65 0-.966-.769-1.752-1.714-1.752zM65.561 31.42c-.331-.513-.498-.77-.502-1.897V8.765c0-.943-.767-1.681-1.747-1.681-.96 0-1.714.738-1.714 1.68v22c0 .652.16 1.278.461 1.809.36.634.902 1.283 2.183 1.283.118 0 .235-.012.348-.035a1.49 1.49 0 0 0 1.046-.817 1.684 1.684 0 0 0-.008-1.477l-.067-.106z"
  })));
};

FullLogoImage.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "118",
  height: "40",
  viewBox: "0 0 118 40"
};
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    page: {
      width: '100%',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    }
  };
});

var IntegrationLogin = function IntegrationLogin() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var classes = useStyles();

  var _useAuthService = (0, _useAuthService2.useAuthService)(),
      apiHost = _useAuthService.apiHost,
      loginUrl = _useAuthService.loginUrl,
      logoutUrl = _useAuthService.logoutUrl;

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      search = _useLocation.search;

  var _qs$parseUrl = _queryString.default.parseUrl(loginUrl),
      url = _qs$parseUrl.url,
      query = _qs$parseUrl.query;

  var fullLoginUrl = _queryString.default.stringifyUrl({
    url,
    query: {
      callbackUrl: "".concat(query.callbackUrl).concat(search)
    }
  });

  var nextPath = (0, _react.useMemo)(function () {
    var parsedSearch = _queryString.default.parse(search);

    return parsedSearch.next || '/';
  }, [search]);

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loginPopUpClosingIntervalRef = _useState2[0],
      setLoginPopUpClosingIntervalRef = _useState2[1];

  var isAuthorizing = !!loginPopUpClosingIntervalRef;
  var logout = (0, _react.useCallback)(function () {
    dispatch((0, _store.logoutRequest)(logoutUrl));
  }, [dispatch, logoutUrl]);
  var clearPopUpClosingInterval = (0, _react.useCallback)(function () {
    if (loginPopUpClosingIntervalRef) {
      clearInterval(loginPopUpClosingIntervalRef);
    }

    setLoginPopUpClosingIntervalRef(undefined);
  }, [loginPopUpClosingIntervalRef]);
  var onLogin = (0, _react.useCallback)(function (data) {
    if (data.success) {
      setTimeout(function () {
        window.location.assign("/login/authorization?next=".concat(nextPath));
      }, 1000);
    }
  }, [nextPath]);
  var onMessage = (0, _react.useCallback)(function (_ref) {
    var origin = _ref.origin,
        data = _ref.data;

    if (!data || origin !== apiHost) {
      return;
    }

    onLogin(data);
    clearPopUpClosingInterval();
  }, [apiHost, onLogin, clearPopUpClosingInterval]);
  var login = (0, _react.useCallback)(function () {
    var auth0Popup = (0, _utils.openPopupWindow)(fullLoginUrl, 'Auth0Popup');
    var popupCloseListener = setInterval(function () {
      if (auth0Popup !== null && auth0Popup !== void 0 && auth0Popup.closed) {
        clearPopUpClosingInterval();
        logout();
      }
    }, 1000);
    setLoginPopUpClosingIntervalRef(popupCloseListener);
  }, [fullLoginUrl, logout, clearPopUpClosingInterval]);
  (0, _react.useEffect)(function () {
    window.addEventListener('message', onMessage);
    return function () {
      window.removeEventListener('message', onMessage);
    };
  }, [onMessage]);

  if (isAuthorizing) {
    return /*#__PURE__*/_react.default.createElement(_AuthLoading.default, null);
  }

  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    spacing: 2,
    className: classes.page
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(FullLogoImage, null)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h2"
  }, "Stop spamming."), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h2"
  }, "Start connecting.")), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    color: "secondary",
    size: "large",
    onClick: login,
    "data-testid": "LoginButton"
  }, "Log in")));
};

var _default = /*#__PURE__*/(0, _react.memo)(IntegrationLogin);

exports.default = _default;